
import { __callbacks } from "Utils/Callbacks/Callback";
import { __emojis } from "Utils/Emoji/emoji";
import styles from "./EmojiWindow.module.scss";



const bodyClick = (e) => {
  if(e.target.classList.contains(styles.emoji)) {
    __callbacks.appendChatInput.trigger(e.target.innerHTML);
  }
}

const onEmojiWindowClose = () => {
  __callbacks.emojiWindow.trigger({show: false});
}

export default function EmojiWindow() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles["container-title"]}>Emoji</div>
        <div className={styles["container-btn-close"]} onClick={onEmojiWindowClose}>
          <img src="./assets/icons/close-black.svg" alt="" srcSet=""></img>
        </div>
      </div>
      <div className={styles.body} onClick={bodyClick}>
        {
          __emojis.map((emoji, index) => {
            return <div key={index} className={styles.emoji}>{emoji}</div>
          })
        }
      </div>
    </div>
  )
}
